<div class="cart-page-container theme-app__bg">
  <bmcore-cart-page [appType]="'PROD-PAGE'" [paymentSource]="paymentSource" [colorSettingsMode]="colorSettingsMode">
  </bmcore-cart-page>
</div>
